export const breakpoints = {
  s: 700,
  md: 1000,
  lg: 1450,
  xl: 1921,
};

export const mediaQueries = (key: keyof typeof breakpoints) => `@media (min-width: ${breakpoints[key]}px)`;
